import Vue from 'vue'
import Alert from '../components/Alert'

export const AlertPlugin = {
    install(Vue, options = {
        timeOut: 10000
    }) {
        Vue.prototype.$alert = (title, content, type = '') => {
            const alertsDivContainer = document.getElementById('alerts'),
                AlertExtend = Vue.extend(Alert),
                AlertComponentInstance = new AlertExtend({ propsData: { title: title, type: type, timeOut: options.timeOut } })

            AlertComponentInstance.$slots.default = [content]
            AlertComponentInstance.$mount()

            alertsDivContainer.appendChild(AlertComponentInstance.$el)

            setTimeout(() => alertsDivContainer.removeChild(AlertComponentInstance.$el), options.timeOut+500)
        }
    }
};